import { Injectable } from '@angular/core';
import { CanActivate } from '@angular/router';

import { Store, select } from '@ngrx/store';
import { Observable, of } from 'rxjs';
import { tap, filter, take, switchMap, catchError } from 'rxjs/operators';

import * as fromStore from '../_store';
import { getTokenStorage } from '@app/core/_shared/services/storage/storage.service';

@Injectable()
export class PermissionUnitsGuard implements CanActivate {
    constructor(private store: Store<fromStore.DashboardState>) {}

    canActivate(): Observable<boolean> {
        return this.checkStore().pipe(
            switchMap(() => of(true)),
            catchError(() => of(false))
        );
    }

    checkStore(): Observable<boolean> {
        return this.store.pipe(
            select(fromStore.getUnitsPermissionsLoaded),
            tap(loaded => {
                if (!loaded) {
                    this.store.dispatch(
                        new fromStore.LoadUnitsPermissions(
                            getTokenStorage()
                        )
                    );
                }
            }),
            filter(loaded => loaded),
            take(1)
        );
    }
}
